import React from 'react';

export const SlackSearchResultIcon = () => (
	<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M15.9995 5C14.3411 5.00122 12.999 6.34436 13.0002 7.99942C12.999 9.65449 14.3423 10.9976 16.0007 10.9988H19.0012V8.00065C19.0025 6.34558 17.6591 5.00245 15.9995 5C16.0007 5 16.0007 5 15.9995 5V5ZM15.9995 13.0001H8.00053C6.34215 13.0013 4.99878 14.3444 5 15.9995C4.99755 17.6546 6.34092 18.9977 7.9993 19.0002H15.9995C17.6579 18.9989 19.0012 17.6558 19 16.0007C19.0012 14.3444 17.6579 13.0013 15.9995 13.0001Z"
			fill="#36C5F0"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M35.0002 15.9995C35.0014 14.3444 33.658 13.0013 31.9996 13.0001C30.3413 13.0013 28.9979 14.3444 28.9991 15.9995V19.0002H31.9996C33.658 18.9989 35.0014 17.6558 35.0002 15.9995ZM27 15.9995V7.99942C27.0012 6.34558 25.659 5.00245 24.0007 5C22.3423 5.00122 20.9989 6.34436 21.0001 7.99942V15.9995C20.9977 17.6546 22.3411 18.9977 23.9994 19.0002C25.6578 18.9989 27.0012 17.6558 27 15.9995Z"
			fill="#2EB67D"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M23.9996 35.0001C25.658 34.9989 27.0014 33.6558 27.0002 32.0007C27.0014 30.3456 25.658 29.0025 23.9996 29.0013H20.9991V32.0007C20.9979 33.6545 22.3412 34.9977 23.9996 35.0001ZM23.9996 26.9988H31.9998C33.6582 26.9976 35.0016 25.6544 35.0004 23.9993C35.0028 22.3443 33.6594 21.0011 32.0011 20.9987H24.0008C22.3425 20.9999 20.9991 22.3431 21.0003 23.9981C20.9991 25.6544 22.3412 26.9976 23.9996 26.9988Z"
			fill="#ECB22E"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5.00031 24.0003C4.99908 25.6554 6.34246 26.9985 8.00084 26.9997C9.65922 26.9985 11.0026 25.6554 11.0014 24.0003V21.0009H8.00084C6.34246 21.0021 4.99908 22.3452 5.00031 24.0003ZM13.0005 24.0003V32.0004C12.998 33.6555 14.3414 34.9986 15.9998 35.0011C17.6582 34.9998 19.0016 33.6567 19.0003 32.0016V24.0027C19.0028 22.3477 17.6594 21.0045 16.001 21.0021C14.3414 21.0021 12.9993 22.3452 13.0005 24.0003C13.0005 24.0015 13.0005 24.0003 13.0005 24.0003Z"
			fill="#E01E5A"
		/>
	</svg>
);
